export default "__VITE_ASSET__oeitBmJY__"